<template>
<b-form @submit="onSubmit">
  <h1>{{ $t('privatePage.instructions_header') }}</h1>
    <b-col lg="10" style="padding-left: 0px; padding-right: 0px;">

      <b-tabs ref="langTabs" v-if="currentPage.translations">
        <b-tab v-for="(translation, translationIdex) in currentPage.translations"
              :key="translation.languageId"
              :title="getLanguageName(translation.languageId)">
          <template v-if="!!!translation.isHidden">
            <b-row style="margin-left: 0px; margin-right: 0px;">
            <b-col lg="8" class="col-content">
            <b-form-group>
              <vue-editor :id="`editor_a${translationIdex}_${tabIdentifier}`" v-model="translation.text"></vue-editor>
            </b-form-group>

            <b-form-group style="margin-top: 30px;">
              <b-form-checkbox :id="`disableQuestion${translationIdex}_${tabIdentifier}`"
                        v-model="currentPage.disableQuestion">
                        {{$t('privatePage.instruction_disable_question')}}
              </b-form-checkbox>
            </b-form-group>

            <div style="margin-bottom: 30px;" v-show="!currentPage.disableQuestion">
            <b-card no-body style="margin-bottom: 1rem;">
              <b-card-header style="padding: 0px; border: none;">
                <b-button block href="#" v-b-toggle="'exerciseQuestion'" variant="primary" style="text-align: left; color: #fff; padding: 15px; width: 100%;">
                  {{$t('privatePage.instruction_exerciseQuestion_header')}}
                </b-button>
              </b-card-header>
              <b-collapse :id="'exerciseQuestion'" role="tabpanel">
                <b-card style="border: none !important;">
                  <b-card>
                    <bp-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="translation.translatedQuestion"
                              :isPartOfCollection="false"
                              v-if="questionFormat(1)" >
                    </bp-module>
                    <gverb-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="translation.translatedQuestion"
                              :isPartOfCollection="false"
                              v-else-if="questionFormat(2)">
                    </gverb-module>
                    <gnum-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="currentPage.question"
                              :isPartOfCollection="false"
                              v-else-if="questionFormat(3)">
                    </gnum-module>
                    <gfair-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="currentPage.question"
                              :isPartOfCollection="false"
                              :isRandomLogicTest="false"
                              v-on:showImageBank="showImageBank"
                              v-else-if="questionFormat(4)">
                    </gfair-module>
                    <gfig-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="currentPage.question"
                              :isPartOfCollection="false"
                              v-on:showImageBank="showImageBank"
                              v-else-if="questionFormat(5)">
                    </gfig-module>
                    <tso-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="translation.translatedQuestion"
                              :isPartOfCollection="false"
                              v-else-if="questionFormat(6)">
                    </tso-module>
                    <ledord-module :isDefaultLanguage="selectedCulture.languageId === translation.languageId"
                              :question="translation.translatedQuestion"
                              :isPartOfCollection="false"
                              v-else-if="questionFormat(8)">
                    </ledord-module>
                  </b-card>
                  <b-card style="margin-top: 1.25rem; background-color: #f5f4f4">
                    <h2 style="font-weight: bold; margin-bottom: 1.5rem;">{{ $t('privatePage.instruction_answerMessages_header') }}</h2>
                    <b-form-group id="correctAnswer">
                      <span>{{$t('privatePage.correctAnswerMessage')}}:</span>
                        <b-form-textarea rows="1" v-model="translation.correctAnswerFeedback" />
                    </b-form-group>
                    <b-form-group id="incorrectAnswer">
                      <span>{{$t('privatePage.incorrectAnswerMessage')}}:</span>
                        <b-form-textarea rows="1" v-model="translation.wrongAnswerFeedback" />
                    </b-form-group>
                  </b-card>
                </b-card>
              </b-collapse>
            </b-card>
            </div>

            <b-form-group>
              <vue-editor :id="`editor_b${translationIdex}_${tabIdentifier}`" v-model="translation.text2"></vue-editor>
            </b-form-group>
            </b-col>

            <b-col style="padding-right: 0px;">
              <b-card :header="$t('privatePage.testsuite_email_possible_tags')" style="background-color: #f5f4f4">
                <b-row>
                  <b-col>
                    <span>{questions}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span>{time}</span>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            </b-row>

            <b-form-group>
              <b-button type="submit" class="me-1" @click="beforeSubmit(translation)">{{ $t('save') }}</b-button>
              <b-button type="button" variant="danger" @click.stop="onDeletePage">{{ $t('delete') }}</b-button>
            </b-form-group>
          </template>
        </b-tab>
      </b-tabs>
    </b-col>

    <image-bank v-if="questionFormatId === 4 || questionFormatId === 5" ref="imageBankRef" v-on:onImageSelected="onImageSelected"></image-bank>
  </b-form>
  </template>

<script>
import { VueEditor } from 'vue3-editor'
import misc from '../../js/helpers/misc'
import BpModule from '../../components/scales/questions/modules/bpmodule'
import GverbModule from '../../components/scales/questions/modules/gverbmodule'
import GfairModule from '../../components/scales/questions/modules/gfairmodule'
import GnumModule from '../../components/scales/questions/modules/gnummodule'
import GfigModule from '../../components/scales/questions/modules/gfigmodule'
import TsoModule from '../../components/scales/questions/modules/tsomodule'
import LedordModule from '../../components/scales/questions/modules/ledordmodule'
import imageBank from '../../components/scales/questions/imagebank'

export default {
  name: 'example-questions-page-editor',
  components: {
    VueEditor,
    BpModule,
    GverbModule,
    GfairModule,
    GnumModule,
    GfigModule,
    TsoModule,
    LedordModule,
    imageBank
  },
  computed: {
    tabIdentifier() {
      if (!this.currentPage) {
        return ''
      }
      return this.currentPage.id
        ? this.currentPage.id
        : this.currentPage.pageNum
    }
  },
  created() {
    console.log(this.currentPage)
  },
  methods: {
    beforeSubmit: function(translation) {
      this.currentLanguageId = translation.languageId
    },
    onSubmit: function(evt) {
      evt.preventDefault()
      let page = this.currentPage
      page.languageId = this.currentLanguageId
      page.selectedLanguageId = this.selectedCulture.languageId
      this.$emit('onSubmit', page)
    },
    onDeletePage: function() {
      this.$emit('onDeletePage', this.currentPage)
    },
    getLanguageName: function(languageId) {
      return misc.getLangName(languageId, this.languages)
    },
    questionFormat: function(format) {
      if (format === this.questionFormatId) {
        return true
      }
      return false
    },
    showImageBank: function(image) {
      this.selectedImage = image
      var bank = this.$refs.imageBankRef
      bank.showBank()
    },
    onImageSelected: function(image) {
      this.selectedImage.imageUrl = image.fullPath
    }
  },
  props: {
    currentPage: {},
    languages: {},
    selectedCulture: {},
    pageIndex: 0,
    questionFormatId: 0
  }
}
</script>

<style>
.nav-tabs {
  margin-bottom: 30px;
}
</style>
